import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
  useMemo,
} from "react";
import { loginThirdParty } from "../api/loginThirdParty";
import { api } from "../lib/axios";
import { useLocation } from "react-router-dom";

interface DefaultContextType {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
}

const DefaultContext = createContext<DefaultContextType>({
  isLoggedIn: false,
  setIsLoggedIn: () => {},
});

interface StationProviderProps {
  children: ReactNode;
}

export const DefaultProvider: React.FC<StationProviderProps> = ({
  children,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await loginThirdParty();
      if (response.token) {
        const tokenRes = await api.post("/auth/token", {
          token: response.token,
        });
        setIsLoggedIn(tokenRes.status === 200);
      }
    };
    fetchData();
  }, []);

  const contextValue = useMemo(
    () => ({
      isLoggedIn,
      setIsLoggedIn,
    }),
    [isLoggedIn]
  );

  return (
    <DefaultContext.Provider value={contextValue}>
      {children}
    </DefaultContext.Provider>
  );
};

export const useDefaultContext = (): DefaultContextType => {
  const context = useContext(DefaultContext);
  return context;
};
